import React, { Component } from 'react'
import copy from 'fast-copy'
import { connect } from 'react-redux'
import { 
	updateTask,
} from 'state/actions'

import ControlsLikeContainer from 'components/controls-like-container/controls-like-container'

import { doClickEventListeners } from 'utils'

class TaskText extends Component {
	state = {
		inputValue: '',
        isFocused: false,
        isEditable: !this.props.isSingle
	}

    inputRef = null

    componentWillUpdate = (nextProps, nextState) => {
        if(!this.state.isFocused && nextState.isFocused){
            doClickEventListeners(this.blurInput)
        }else if(this.state.isFocused && !nextState.isFocused){
            doClickEventListeners(this.blurInput, true)
        }
    }

    blurInput = e => {
        if (this.inputRef && !this.inputRef.contains(e.target)) {
            this.inputRef.blur()
        }
    }

	handleChange = e => {
        let value = e.target.value
        
		this.setState({
			inputValue: value
		})
	}

	setFocus = isFocused => {
        const {
            isSingle,
            openMenu
        } = this.props

        if(isSingle){
            return
        }

		let state = {
			...this.state
		}

		state.isFocused = isFocused

		if(!isFocused){
			this.handleSubmit()

			if(this.inputRef){
				this.inputRef.blur()
			}
		}else{
            if(openMenu){
                openMenu(null)
            }
            
			state.inputValue = this.getColumnValue()
		}

		this.setState(state)
	}

	handleSubmit = _ => {
        const {
            task,
            column,
            updateTask
        } = this.props

        const inputValue = this.state.inputValue ? this.state.inputValue : ''

        const tempTask = copy(task)

        if(task.column_data){
            tempTask.column_data[column.id] = inputValue
        }else{
            tempTask.column_data = {
                [column.id]: inputValue
            }
        }

        updateTask(tempTask)

        this.setState({
            inputValue: ''
        })
    }
    
    getColumnValue = _ => {
        const {
            task,
            column
        } = this.props

        if(task && task.column_data && task.column_data[column.id]){
            return task.column_data[column.id]
        }

        return ''
    }

    hasEllipsis = _ => {
        const{
            isCompact
        } = this.props

        const columnValue = this.getColumnValue()

        if(isCompact){
            return columnValue.length > 33
        }else{
            return columnValue.length > 23
        }
    }

    isValueUrl = value => {
        if(value){
            const isUrl = /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/.test(value)
            return isUrl
        }

        return false
    }

    handleClick = e => {
        let columnValue = this.getColumnValue()
        const isUrl = this.isValueUrl(columnValue)

        if(!columnValue.includes('http')){
            columnValue = 'http://'+columnValue
        }

        if(isUrl){
            if(e.metaKey || e.ctrlKey){
                // sounds like it would never happen, but you never know...
                if(this.inputRef){
                    this.inputRef.blur()
                }
                
                window.open(columnValue, '_blank')
            }
        }
    }

    enableEdit = _ => {
        this.setState({
            isEditable: true,
            isFocused: true,
            inputValue: this.getColumnValue(),
        }, _ => {
            if(this.inputRef){
				this.inputRef.focus()
			}
        })
    }

    cancelEdit = _ => {
        this.setState({
            isEditable: false,
            isFocused: false,
            inputValue: ''
        })
    }

    handleSave = _ => {
        this.cancelEdit()
        this.handleSubmit()
    }

	render() {
		const {
			inputValue,
            isFocused,
            isEditable
		} = this.state

		const {
            task,
            isSingle,
            column
		} = this.props

        let className = 'task-estimate task-text tooltip-trigger '
        
        const columnValue = this.getColumnValue()

		if(task && !columnValue){
			className += ' empty'
        }
        
        if(isSingle){
            className += ' editable-input-field'
        }

		let valueString = inputValue

        // looks a litte more optimistic when blurring input
		if(task && columnValue && !isFocused){
			valueString = columnValue ? columnValue : ''
        }

        const hasEllipsis = this.hasEllipsis()
        const isUrl = this.isValueUrl(valueString)

		return (
			<div 
				className={className}
                onMouseEnter={this.getTrackedTime}
                onClick={this.handleClick}
			>
                <input 
					ref={ref => this.inputRef = ref}
					type="text" 
					placeholder={task ? `(No ${ column.type === 'TEXT' ? 'text' : 'link' })` : ''}
					onKeyPress={e => {
                        if(e.key === 'Enter'){
                            if(isSingle){
                                this.handleSave()
                            }else{
                                this.setFocus(false)
                            }
                        }}
                    } 
					onBlur={_ => this.setFocus(false)}
					onChange={this.handleChange}
					value={valueString}
                    onFocus={_ => this.setFocus(true)}
                    disabled={!isEditable}
				/>
                { (hasEllipsis || isUrl) &&
				    <div className="tooltip">
                        { isUrl ? `Cmd+click to open link` : columnValue }
				    </div>
                }
                { isSingle &&
                    <ControlsLikeContainer
                        canEdit={true}
                        isEditing={isEditable}
                        editCallback={this.enableEdit}
                        saveCallback={this.handleSave}
                        cancelCallback={this.cancelEdit}
                    />
                }
			</div>
		)
	}
}

export default connect(null, { 
	updateTask,
})(TaskText)


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/task/task-text.jsx